// @flow
/* eslint-disable no-shadow */
import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { submitContact } from '../../actions/forms'
import { closeContactModal } from '../../actions/modals'
import ContactForm from './components/ContactForm'

type Props = {
  isOpen: boolean,
  submitContact: Function,
  closeContactModal: Function,
  options: object
}

const ContactModal = ({
  isOpen,
  submitContact,
  closeContactModal,
  options
}: Props) => {
  if (!isOpen) return null

  function onSubmit(data) {
    return submitContact({ ...options, ...data })
  }

  return (
    <Modal
      isOpen={isOpen}
      className="modal"
      contentLabel="Contact Form"
      overlayClassName="modal-overlay"
      onRequestClose={closeContactModal}
    >
      <ContactForm
        onSubmit={onSubmit}
        onRequestClose={closeContactModal}
        options={options}
      />
    </Modal>
  )
}

export default connect(
  (state) => ({
    isOpen: state.modals.contactModalOpen,
    options: state.modals.contactModalOptions
  }),
  {
    submitContact,
    closeContactModal
  }
)(ContactModal)



// WEBPACK FOOTER //
// ./src/components/ContactModal/index.js